// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const BadgeText = createStyle({
  // textTransform: 'uppercase',
});
